import { useFleet } from "../fleet/FleetContext";

export function FleetSwitcher() {
  const { fleets, currentId, setCurrentId, isLoading, isError } = useFleet();

  if (isError) {
    return <span className="fleet-switcher fleet-switcher--error">Fleets unavailable</span>;
  }

  return (
    <label className="fleet-switcher">
      <span className="visually-hidden">Fleet</span>
      <select
        className="fleet-switcher__select"
        value={currentId}
        disabled={isLoading || fleets.length === 0}
        onChange={(e) => setCurrentId(e.target.value)}
        aria-label="Switch fleet"
      >
        {isLoading && <option>Loading…</option>}
        {!isLoading &&
          fleets.map((fleet) => (
            <option key={fleet.id} value={fleet.id}>
              {fleet.name}
            </option>
          ))}
      </select>
    </label>
  );
}
